import { PresentOnAdmission } from 'src/contracts/presentOnAdmission';

export function poaText(poa: PresentOnAdmission | undefined): string | undefined {
  if (!poa) {
    return undefined;
  }
  return enumKey(poa) + ' - ' + poa.valueOf();
}

export function convertPOA(poa: string): PresentOnAdmission | undefined {
  return PresentOnAdmission[poa as keyof typeof PresentOnAdmission];
}

function enumKey(poa: PresentOnAdmission): string {
  return POAMap.get(poa) || '';
}

const POAMap: ReadonlyMap<PresentOnAdmission, string> = new Map([
  [PresentOnAdmission.Y, 'Y'],
  [PresentOnAdmission.N, 'N'],
  [PresentOnAdmission.U, 'U'],
  [PresentOnAdmission.W, 'W'],
  [PresentOnAdmission.I, 'I'],
]);
